import * as React from 'react';

import Markdown from 'bundles/cms/components/Markdown';
import AccordionListModule from 'bundles/degree-description/components/modules/program-details/AccordionListModule';

export type CurriculumItem = {
  id: string;
  title: string;
  supportText: string;
  answer: string;
};

export type CurriculumModuleProps = {
  heading: string;
  description?: string;
  items: CurriculumItem[];
};

const CurriculumModule = ({ heading, description, items }: CurriculumModuleProps) => (
  <AccordionListModule
    heading={heading}
    description={description}
    sections={[
      {
        items: items.map((item) => ({
          id: item.id,
          label: item.title,
          supportText: item.supportText,
          content: <Markdown source={item.answer} trackingName="curriculum_link" />,
        })),
      },
    ]}
  />
);

export default CurriculumModule;
